export default __webpack_public_path__ + "static/media/compnyimg.d022290d.jpeg";